<template>
  <div>
    <h1>회원명단 관리</h1>
    <div>
      <input type="text" placeholder="이름을 입력해 주세요" autofocus>
      <button>검색</button>
    </div>
    <div>
      <ul>
        <li>
          이름
        </li>
        <li>
          이메일
        </li>
        <li>
          가입일
        </li>
        <li>
          계정삭제
        </li>
      </ul>
      <ul>
        <li>
          안녕하
        </li>
        <li>
          Hello@naver.com
        </li>
        <li>
          A
        </li>
        <li>
          19. 07. 01
        </li>
        <li>
          <button>삭제</button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ManageMember.vue